
















import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { Validator } from "vee-validate";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class InvestmentAccountTypeChangeSlots extends Vue {
  $validator: Validator;

  drivewealthStore = useDrivewealthStore();

  @Prop({required: false})
  accountId: number;

  mounted (): void {
    this.drivewealthStore.getAccountSummaryV2({ dwAccountId: this.accountId });
    this.drivewealthStore.loadPendingActivityByAccount(
          { username: null, partnerId: null, accountId: this.accountId });
  }

  get isLoaded (): boolean {
    const accountSummaryV2Loaded = this.drivewealthStore.accountSummaryV2Loaded(this.accountId);

    return this.drivewealthStore.pendingActivityV2Loaded(this.accountId)
      && accountSummaryV2Loaded;
  }

  get hasHoldings (): boolean {
    const accountSummary = this.drivewealthStore.accountSummaryById(this.accountId);
    if (accountSummary) {
      return accountSummary.holdings && accountSummary.holdings.length > 0;
    }

    return false;
  }

  get hasPendingActivity (): boolean {
    const pendingActivityLoaded = this.drivewealthStore.pendingActivityV2Loaded(this.accountId);
    const pendingActivityForAccount = this.drivewealthStore.pendingActivityById(this.accountId);

    return pendingActivityLoaded &&
      pendingActivityForAccount &&
      pendingActivityForAccount.pendingOrders.length > 0;
  }
}
